// See Design system: https://www.figma.com/file/BkPALTSRIDsNtMbs55hWeN/%F0%9F%8E%A8-Jotun-Digital-Design-System-Version-1.0.4---DEPT?type=design&node-id=31-13&mode=design&t=2WhTFMSLrUjDcDmh-0
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../tailwind.config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fullConfig = resolveConfig(tailwindConfig as any);
const colourConfig = fullConfig.theme.colors;

const greyBackgrounds = {
  gray1: colourConfig.grey[10],
  gray2: colourConfig.grey[20],
  gray3: colourConfig.grey[70],
  gray4: colourConfig.grey[80],
  gray5: colourConfig.grey[90],
  gray6: colourConfig.grey[100],
  black: colourConfig.black.DEFAULT,
};

const backgroundColours = {
  ...colourConfig.background,
  ...greyBackgrounds,
};

export const darkBackgrounds = [
  'amberDark',
  'brownGray',
  'brownGrey',
  'coralDark',
  'gBSGreen',
  'gBSLightGreen',
  'gBSPalmGreen',
  'graphite',
  'gray4',
  'gray5',
  'gray6',
  'jotunBlue',
  'oceanDark',
  'oliveDark',
  'slateDark',
];

export default backgroundColours;
